import { SectionHeading } from "@/components/vendor/Brand";

const COLS = ["Service", "Our Est.", "Your Rate"];

export const ServicesTable = ({ catalog, values, onRate }) => (
  <section className="hx-section" data-testid="services-section">
    <SectionHeading testId="services-heading">{catalog.services_heading}</SectionHeading>
    <p className="hx-section__note" data-testid="services-note">{catalog.services_note}</p>
    <table className="hx-table hx-table--stack" data-testid="services-table">
      <thead>
        <tr>{COLS.map((c) => <th key={c}>{c}</th>)}</tr>
      </thead>
      <tbody>
        {catalog.services.map((s) => (
          <tr key={s.id} data-testid={`service-row-${s.id}`}>
            <td data-label={COLS[0]} className="hx-strong">{s.label}</td>
            <td data-label={COLS[1]} className="hx-est">{s.our_estimate}</td>
            <td data-label={COLS[2]}>
              <input
                className="hx-input"
                placeholder="Your rate or N/A"
                value={values[s.id]}
                maxLength={60}
                onChange={(e) => onRate(s.id, e.target.value)}
                aria-label={`Your rate for ${s.label}`}
                data-testid={`service-rate-input-${s.id}`}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </section>
);
